export const OPEN_US_MODAL = 'openUsModal';
export const OPEN_EU_DUTY_MODAL = 'openEuDutyModal';
export const CLOSE_EU_DUTY_MODAL = 'closeEuDutyModal';
export const ADDED_DELIVERY_PASS = 'addedDeliveryPass';
